import type { SeoConfig } from '@klaro7/shared-types';

/** Replaces {placeholder} tokens; collapses leftover whitespace from empty values. */
export function resolveSeoTemplate(
  template: string,
  values: Record<string, string | undefined>
): string {
  return template
    .replace(/\{(\w+)\}/g, (_match, key: string) => values[key] ?? '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

/** Appends the global title suffix unless already present. */
export function withTitleSuffix(title: string, config?: SeoConfig): string {
  const suffix = config?.global.titleSuffix ?? '';
  if (!suffix || title.includes(suffix.trim())) return title;
  return `${title}${suffix}`;
}

export function truncateDescription(text: string, max = 160): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  return `${cut.slice(0, Math.max(cut.lastIndexOf(' '), max - 20))}…`;
}
